








































import NavButton from '@/components/shared/NavButton'
import MachineComponent from '@/components/MachineComponent'
import { ISnackbar, MachineSettings } from '@/model'
import { Pages } from '@/pages'
import { mapGetters } from 'vuex'
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {
    NavButton: NavButton,
    MachineComponent: MachineComponent
  },
  computed: {
    ...mapGetters ('machinesettings', [
      'machinesettings',
      'fixedMachineSettings'
    ]),
    ...mapGetters('palletpatterns', ['palletPatternsCount']),
  }
})
export default class MachineSettingView extends Vue {
  private homeRouteLink: string = Pages.HOME.routeLink
  private snackbar: ISnackbar = { show: false, color: '', text: '', timeout: 10000 }

  private save(machineSettings: MachineSettings, fixed: boolean) {
    this.snackbar.show = true
    this.snackbar.color = 'success'
    this.snackbar.text = String(this.$t('general.settingsSaved'))
    this.$store.dispatch('machinesettings/updateMachineSettings', machineSettings)
    this.$store.dispatch('machinesettings/setFixedMachineSettings', fixed)
  }

  private route () {
    this.$router.push(this.homeRouteLink)
  }
}
